import { atom } from 'jotai';

export const searchStateAtom = atom<{ open: boolean }>({
    open: false,
});
